import React from 'react';
import { ProductCard } from '../components/ProductCard';
import { THERMACUBE_COMPARE_AT_INR, THERMACUBE_PRICE_INR, THERMACUBE_PRODUCT_STUDIO } from '../constants/thermaCube';

const STATIC_PRODUCTS = [
  {
    id: 'thermacube',
    name: 'ThermaCube',
    category: 'hot-cold-therapy',
    price: THERMACUBE_PRICE_INR,
    original_price: THERMACUBE_COMPARE_AT_INR,
    image: THERMACUBE_PRODUCT_STUDIO,
    short_description: 'Hot, cold, and contrast in one wearable — simple recovery you can take anywhere.',
    rating: 4.9,
    reviews_count: 847,
    features: [
      'Instant heat (up to 45°C) & cold (down to 10°C)',
      'Three therapy modes: Heat, Cold, Contrast',
      'Adjustable straps (short + long) — best grip on knees & legs',
      'Rechargeable — up to 4 hours battery life',
      'Compact & portable — fits in your bag',
      '1-year warranty · 30-day return policy (see Terms)',
    ],
  },
];

export const Products = () => {
  return (
    <div data-testid="products-page" className="min-h-screen pt-[132px] pb-16 px-4 md:px-8 tech-grid-bg">
      <div className="max-w-[800px] mx-auto">
        {/* Header */}
        <div className="mb-12 md:mb-16 text-center">
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">SprintFit · ThermaCube</span>
          <h1 className="font-heading text-5xl md:text-6xl font-bold uppercase tracking-[0.06em] mt-3 text-white">
            Therma<span className="text-[#9fd4c9]">Cube</span>
          </h1>
          <p className="text-zinc-500 text-lg mt-4 max-w-2xl mx-auto leading-relaxed">
            Hot, cold, and contrast in one device. See the home page FAQ for placement and strap tips.
          </p>
        </div>

        {/* Products Grid */}
        <div className="space-y-8">
          {STATIC_PRODUCTS.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};
